import type { WLatestBlogPostsTranslations } from "./pl";

export const de: WLatestBlogPostsTranslations = {
  readMore: "Mehr lesen",
  showAll: "Alle anzeigen",
};
